// Header displays a builder brand can have (Brand::HEADER_DISPLAYS).
const LOGO_ONLY = 'logoOnly';
const TEXT_ONLY = 'textOnly';

/**
 * Resolves which parts of the brand mark the header shows, the way the
 * resident site does. A brand without a header display has a logo-only header,
 * and a text-only header without text falls back to the logo.
 * @param {{ header_display: ?string, header_text: ?string }} brand gon.brand
 * @returns {{ headerText: string, showLogo: boolean, showText: boolean }}
 */
export const resolveHeaderDisplay = (brand) => {
  const headerDisplay = brand.header_display || LOGO_ONLY;
  const headerText = brand.header_text?.trim() || '';

  return {
    headerText,
    showLogo: headerDisplay !== TEXT_ONLY || !headerText,
    showText: headerDisplay !== LOGO_ONLY && !!headerText,
  };
};
